import { Input } from "antd";

const InputField = ({ type, placeholder, value, ...rest }) => {
  return (
    <Input
      type={type}
      placeholder={placeholder}
      value={value}
      className="form-control rounded-md"
      {...rest}
    />
  );
};

export default InputField;
